import { ModalConfig } from '../../../contexts/modalContext';

import QleOverrideReasonModal from './QleOverrideModal';

export const modalConfig: ModalConfig = {
    'overrideQLEDocumentsModal': {
        id: 'overrideQLEDocumentsModal',
        modalComponent: QleOverrideReasonModal
    }
};
